import React, {Component} from "react";
import {version} from "../../../../package.json";
import {config} from "@/config";
import cryptoJs from "crypto-js";
import padZeroPadding from "crypto-js/pad-zeropadding";
import Utf8 from "crypto-js/enc-utf8";
import {hostnameBanList} from "@/constants/hostnameBanList.js";

const key = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);
const iv = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);

const {websiteId} = config;
const isDev = window.config.isDev;

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
    this.reportErrorLog = this.reportErrorLog.bind(this);
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  componentDidCatch(error, info) {
    if (isDev) {
      console.error("ErrorBoundary caught an error", error, info);
      return;
    }

    this.reportErrorLog(error, info);

    if (window.newrelic) {
      window.newrelic.noticeError(error, {...info});
    }
  }

  async reportErrorLog(error, info) {
    const msg = (error && (error.message || error.toString())) || "";
    if (msg.includes("Unable to preload CSS") || msg.includes("dynamically imported module")) {
      try {
        window.dispatchEvent(new CustomEvent("app:chunk-failed", {detail: {message: msg}}));
      } catch (error) {
        //
      }
      return;
    }

    const payload = {
      error: error.toString(),
      log: info.componentStack,
      appVersion: version,
      appRoute: window.location.pathname,
      websiteId,
      customerDevice: navigator.userAgent,
    };

    if (!isDev && payload.log?.trim()) {
      try {
        let headers;
        let body;
        let res;

        if (hostnameBanList.includes(window.location.hostname)) {
          headers = new Headers({
            "Content-Type": "application/json",
          });
          body = JSON.stringify(payload);
        } else {
          headers = new Headers({
            "Content-Type": "text/html",
          });
          body = cryptoJs.AES.encrypt(JSON.stringify(payload), key, {
            iv,
            padding: padZeroPadding,
          }).toString();
        }

        const response = await fetch(`${import.meta.env.VITE_API_ROOT}/report-crash-error`, {
          method: "POST",
          headers,
          body,
        });

        if (hostnameBanList.includes(window.location.hostname)) {
          res = await response.json();
        } else {
          const data = await response.text();
          const {data: dataResponse} = JSON.parse(data);

          const dataDecrypted = cryptoJs.AES.decrypt(dataResponse, key, {
            iv,
          }).toString(Utf8);

          res = JSON.parse(dataDecrypted);
        }

        if (res.error) {
          console.error("Error: " + res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  render() {
    if (this.state.hasError && !isDev) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
